NotificationHelper = LP.module 'NotificationHelper'
Articles = LP.module 'Articles'
Analytics = LP.module 'Analytics'

Articles.show = ->
  Analytics.track 'Viewed Article', {'Article Title': $.trim($('.article h1').text())}
  LP.module('Share').bindRRPShareButtons()

ArticlesForm =
  init: ->
    $('#article_sub_header_text_count').textCounter
      target: '#article_sub_header'
      count: 160
      alertAt: 20
      warnAt: 10
      stopAtLimit: true
    this.save()
    Articles.initSummernote()
  save: ->
    $('#article-save').on 'click', (e) ->
      e.preventDefault();
      $form = $('form.article-form')
      $.ajax
        url: $form.prop('action'),
        data: $form.serialize(),
        type: $form.prop('method'),
        dataType: 'json',
        success: (data) ->
          $form.prop(action: data.action) if (data && data.action)
          NotificationHelper.success "Article successfully saved", autohide: 2000
        error: (data) ->
          NotificationHelper.error $.parseJSON(data.responseText).errors.join('<br>'), autohide: 3000

Articles.edit = ->
  ArticlesForm.init()

Articles.new = ->
  ArticlesForm.init()

Articles.update = ->
  ArticlesForm.init()

Articles.create = ->
  ArticlesForm.init()

Articles.initSummernote = ->
 `import(/* webpackChunkName: "vnd-forms" */ 'js/vendor/forms')`.then(() ->
    $('.summernote').summernote
      height: 600
      dialogsInBody: false
      disableDragAndDrop: true
      disableResizeEditor: true
      toolbar: [
        ['style', ['style']],
        ['color', ['color']],
        ['font', ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']],
        ['fontsize', ['fontsize']],
        ['insert', ['link', 'hr']],
        ['height', ['height']],
        ['view', ['codeview']],
        ['para', ['paragraph', 'ul', 'ol']],
        ['table', ['table']]
        ['help', ['help']]
      ]
      callbacks:
        onInit: ->
          $('.summernote-spinner').hide()
 )

summernoteFixPasteOnModals = ->
# Image Modal - toggle button on mouse paste & toggle button back to disabled when modal is hidden
  $('.modal.image-dialog').on('paste', '.note-image-url', (e) ->
    $dialog = $(@).parents('.image-dialog')
    $button = $dialog.find('.note-image-btn').last()
    setTimeout (->
      $.summernote.ui.toggleBtn($button, true) if $button.hasClass('disabled')
    ), 0
    $.summernote.ui.onDialogHidden($dialog, ->
      $.summernote.ui.toggleBtn($button, false) unless $button.hasClass('disabled')
    )
  ).trigger('focus')
